<script lang="ts">
	import { onMount } from 'svelte';
	import * as qs from 'qs';
	import Router, { location,push,querystring } from 'svelte-spa-router';
	import routes from './routes';
	import Header from './routes/header/header.svelte';
	import Swal from 'sweetalert2'
	import configs from './config';
	import Box from './routes/themes/themes.svelte';
	import PwaBanner from './routes/Member/PwaBanner.svelte';
	import PushPrompt from './routes/Member/PushPrompt.svelte';
	import { initPush, reportInstall } from './push';
	
	let foo = 'baz'
	let bar = 'qux'
	let result = <any>{}
		// let resp = appStart.checkAPI()
	
	let header = false

	let srcBg = '/assets/images/bg_cs1.jpg'

	let title = 'AMBBET'

	let promise
    let analytic = ''
	let themeType = ''
	$: {
		promise = checkAPI();
		
	}
	let paramsx = new URLSearchParams($querystring);
	let logintoken = paramsx.get('logintoken')
	let vtext = ''
	if(logintoken){
		if(logintoken!=''){
			vtext = '?token='+logintoken
		}
	}

	async function checkAPI() {
		const res = await fetch(configs.cloudapi+"/cloud/configs", {
			method: 'POST',
			headers:{
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: qs.stringify({})
		})
		
		const xjson = await res.json()
		if(xjson.statusCode==200){
			window.localStorage.setItem("setting",JSON.stringify(xjson.payload))
			window.localStorage.setItem("appid",JSON.stringify(xjson.payload.web_id))
			window.localStorage.setItem("apiurl",configs.cloudapi+"/")
            if(xjson.payload.fixsource){
                if(Number(xjson.payload.fixsource)!=0){
                    window.localStorage.setItem("registerid",xjson.payload.fixsource)
                }
            }
            if(xjson.payload.analytic){
                analytic = xjson.payload.analytic
            }
            title = xjson.payload.title
            let positionReg = $location.search("register");
            let positionReset = $location.search("resetpassword");
            let positionPwa = $location.search("pwa-install");
            if(positionReg==-1 && positionReset==-1 && positionPwa==-1){
                if(!window.localStorage.getItem('access_token')){
                    
                    push("/auth"+vtext)
                }else{
                    if(window.localStorage.getItem('access_token')==''){
                        push("/auth"+vtext)
                    }else{
                        header = true
                        // login แล้ว → ลงทะเบียนรับ push noti (เงียบ ๆ, ไม่ block UI)
                        initPush()
                        // เปิดแบบ PWA (standalone) → บันทึกการติดตั้งสำหรับ report ใน BO
                        reportInstall()
                    }
                }
            }
			if(xjson.payload.themes){
				themeType = xjson.payload.themes
			}else{
				themeType = 'default'
			}
			//themeType = 'gold'
		}else{
			push("/error")
		}
	}
	async function countMessage() {
		if(!window.localStorage.getItem('access_token')){
			return false
		}
		if(window.localStorage.getItem('access_token')==''){
			return false
		}
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/countmessage", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
			
            if(json.payload.alert == 1){
				Swal.fire({
                    heightAuto: false,
                    title: json.payload.alertdata.title,
                    html: json.payload.alertdata.message,
                    icon: 'success',
                    confirmButtonText: 'OK' 
                })
			}
		} else {
            throw new Error(json);
		}
    }
	
    let ms = 5000
    let counter = 0
	// countMessage()
    
    let clear
    $: {
        // clearInterval(clear)
        // clear = setInterval(countMessage, ms)
    }
    // let dataRandom = [
	// 	"https://karacli.com/",
	// 	"https://karacli.com/%e0%b8%aa%e0%b8%a5%e0%b9%87%e0%b8%ad%e0%b8%95%e0%b8%a7%e0%b8%ad%e0%b9%80%e0%b8%a5%e0%b8%97/",
	// 	"https://karacli.com/%e0%b8%9a%e0%b8%b2%e0%b8%84%e0%b8%b2%e0%b8%a3%e0%b9%88%e0%b8%b2%e0%b8%ad%e0%b8%ad%e0%b8%99%e0%b9%84%e0%b8%a5%e0%b8%99%e0%b9%8c/",
	// 	"https://karacli.com/%e0%b8%aa%e0%b8%a5%e0%b9%8a%e0%b8%ad%e0%b8%95%e0%b8%ad%e0%b8%ad%e0%b8%99%e0%b9%84%e0%b8%a5%e0%b8%99%e0%b9%8c/",
	// 	"https://karacli.com/%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%a3%e0%b8%b2/"
	// ]
	// let iframeUrl = dataRandom[Math.floor((Math.random()*dataRandom.length))];

</script>

<svelte:head>
	<title>{title}</title>
    <meta name="viewport" content="user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, target-densitydpi=device-dpi" />
	<link rel="stylesheet" href="assets/bootstrap/css/bootstrap.min.css">
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100&family=Prompt:wght@200;300;400;500;600;700&display=swap" rel="stylesheet">
    {@html analytic}
</svelte:head>
	{#if header}<PwaBanner />{/if}
	<PushPrompt />

	<div class="container content-wrapper themes {themeType}" style="position: relative;">
		<Box />
	{#await promise}
	{:then number}
	
	<Router {routes} />
	
	
	{:catch error}
	{/await}
	<script src="assets/bootstrap/js/bootstrap.bundle.min.js" integrity="sha384-w76AqPfDkMBDXo30jS1Sgez6pr3x5MlQ1ZAGC+nuZB+EYdgRZgiwxhTBTkF7CXvN" crossorigin="anonymous"></script>

	<script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
	
	<footer></footer>
	
	</div>
	

<style>
	.ahidden{
		display: none;
	}
	.content-wrapper{
		/* width: 373px!important;
    	max-width: 374px!important; */
		min-height: 100%;
		display: table;
	}
	.bg-warMain{
		background-color: #171717 !important;
	}

	
	@media only screen and (min-device-aspect-ratio:1920 / 1080){
		:global(body){
			zoom:160%
		}
		:global(.swal2-container.swal2-center>.swal2-popup){
			max-width: 400px;
    		zoom: 70%;
		}
		.content-wrapper{
			display:table
		}
		.container,.content-wrapper{
			width:374px!important;
			max-width:374px!important
		}

	}
	@media only screen and (min-device-aspect-ratio:512/683){
		:global(body){
			zoom:160%
		}
		:global(.swal2-container.swal2-center>.swal2-popup){
			max-width: 400px;
    		zoom: 70%;
		}
		.content-wrapper{
			display:table
		}
		.container,.content-wrapper{
			width:374px!important;
			max-width:374px!important 
		}
	}
	@media only screen and (min-width:1080px) and (max-device-aspect-ratio:4/3){
		:global(body){  
			zoom:260%
		}
		:global(.swal2-container.swal2-center>.swal2-popup){
			max-width: 400px;
    		zoom: 70%;
		}
	}
	:global(body){ 
			padding-top: 0;
			padding-bottom: 0;
			/* background-image: url('./images/BG.png'); */
			/*background-image: url('../assets/images/bg_cx2.jpg');*/
			 background:linear-gradient(0deg, #2e2e2e47,#2e2e2e47), url('../assets/images/bg6.jpg');
			/* background-image: url('../assets/images/bg6.jpg');   */
			background-size: cover;
			font-family: 'Prompt', sans-serif !important;
			/* font-weight: 200 !important; */
			font-size: 0.8rem !important;
			background-repeat: no-repeat;
			background-attachment: fixed;
			background-position: center;
			padding-left: 0px;
			padding-right: 0px;
	}
	:global(.btn-gd){
		color: rgb(230, 196, 119) !important;
    	border: 1px solid rgb(230, 196, 119) !important;
	}
    

</style>
